// extracted by mini-css-extract-plugin
export default {"container":"ReviewModel_container__QiUVK"};